var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roe-error-message',{attrs:{"field":_vm.design.s_147_employer_match_trueup_frequency}},[_c('v-select',{attrs:{"options":[
      { code: 1, label: 'Per Payroll' },
      { code: 2, label: 'Monthly' },
      { code: 3, label: 'Quarterly' },
      { code: 4, label: 'Semi-Annual' },
      { code: 5, label: 'Annual' }
    ],"reduce":function (label) { return label.code; },"required":""},model:{value:(_vm.design.$model.s_147_employer_match_trueup_frequency),callback:function ($$v) {_vm.$set(_vm.design.$model, "s_147_employer_match_trueup_frequency", $$v)},expression:"design.$model.s_147_employer_match_trueup_frequency"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }